var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.504 18c.094 0 .183-.024.266-.073.083-.049.149-.113.199-.194.05-.081.074-.168.074-.26v-4.445h4.417c.095 0 .184-.023.267-.07.082-.046.149-.11.198-.19.05-.082.075-.17.075-.268 0-.097-.025-.185-.075-.264-.05-.079-.116-.142-.198-.19-.083-.05-.172-.074-.267-.074h-4.417V7.521c0-.097-.025-.185-.074-.264-.05-.079-.116-.141-.2-.188-.082-.046-.17-.069-.265-.069-.1 0-.191.023-.274.07-.083.046-.149.108-.199.187-.05.079-.074.167-.074.264v4.451h-4.41c-.1 0-.19.025-.27.073-.08.049-.147.112-.199.191-.052.079-.078.167-.078.264s.026.186.078.267c.052.081.118.145.199.191.08.047.17.07.27.07h4.41v4.444c0 .093.025.18.074.26.05.082.116.146.2.195.082.049.173.073.273.073z",
    transform: "translate(-176 -100) translate(169 93)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusWhite);
export default __webpack_public_path__ + "static/media/ic_plus_white.4ab15c5244af5c2ba870a573d1228f93.svg";
export { ForwardRef as ReactComponent };